import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { renderFeatureStyle as renderStyle } from './Functions';
import { Root, MapContainer } from './styles';
import Itinerary from '../Itinerary/index';

const itineraryKeyName = 'common:plan.filter.placeholder';

class Plan extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentZoom: null,
      fontSize: 10,
      renderedData: false,
      selectedItem: null,
      itinerary: false
    };

    this.MapFloors = {
      '-1': '-1',
      '0': '0'
    };
    this.MapLayers = {};
  }

  componentDidMount() {
    const { data } = this.props;

    this.renderMap();

    if (data && data.length > 0) {
      this.renderPlaces(data);
    }
  }

  static getDerivedStateFromProps(props, state) {
    const { currentZoom, itineraryStart, itineraryFinish, translator } = props;
    // Change zoom
    if (currentZoom !== state.currentZoom) {
      if (currentZoom > 18.5) {
        return {
          currentZoom: currentZoom,
          fontSize: currentZoom / 2
        };
      } else if (currentZoom <= 18) {
        return {
          currentZoom: currentZoom,
          fontSize: 7.5
        };
      } else {
        return {
          currentZoom: currentZoom,
          fontSize: 10
        };
      }
    }

    const itinerary =
      itineraryStart.label !== translator(itineraryKeyName) ||
      itineraryFinish.label !== translator(itineraryKeyName);

    if (itinerary !== state.itinerary) {
      return {
        itinerary
      };
    }

    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      currentFloor,
      currentZoom,
      selectedItem,
      defaultSelectItem,
      itineraryStart,
      itineraryFinish,
      translator,
      data
    } = this.props;
    const { itinerary } = this.state;

    // Change floor
    if (currentFloor !== prevProps.currentFloor) {
      this.MapSelect.getFeatures().clear();

      if (currentFloor === 0) {
        this.MapLayers['-1'].setVisible(false);
        this.MapLayers['0'].setVisible(true);
        this.MapLayers['infoFloor0'].setVisible(true);
      } else {
        this.MapLayers['-1'].setVisible(true);
        this.MapLayers['0'].setVisible(false);
        this.MapLayers['infoFloor0'].setVisible(false);
      }
    }

    // Change zoom
    if (prevState.currentZoom !== this.state.currentZoom) {
      if (currentZoom > 18.5) {
        this.setState({
          currentZoom: currentZoom,
          fontSize: currentZoom / 2
        });
      } else {
        this.setState({
          currentZoom: currentZoom,
          fontSize: 10
        });
      }

      this.renderPlaces(data);
    }

    // Itinerary
    if (
      itineraryStart.label !== translator(itineraryKeyName) ||
      itineraryFinish.label !== translator(itineraryKeyName)
    ) {
      if (itineraryFinish.floor !== itineraryStart.floor) {
        this.MapLayers['-1'].setVisible(true);
        this.MapLayers['0'].setVisible(true);
        this.MapLayers['infoFloor0'].setVisible(true);

        this.itinerary(
          itineraryStart.floor.toString(),
          itineraryStart,
          itineraryFinish
        );
        this.itinerary(
          itineraryFinish.floor.toString(),
          itineraryStart,
          itineraryFinish
        );
      } else {
        const hiddenFloor =
          itineraryStart.floor.toString() === '-1' ? '0' : '-1';
        this.MapLayers[hiddenFloor].setVisible(false);

        if (itineraryStart !== prevProps.itineraryStart) {
          this.itinerary(
            itineraryStart.floor.toString(),
            itineraryStart,
            itineraryFinish
          );
        }

        if (itineraryFinish !== prevProps.itineraryFinish) {
          this.itinerary(
            itineraryFinish.floor.toString(),
            itineraryStart,
            itineraryFinish
          );
        }
      }

      this.setState({
        itinerary: true
      });
    } else {
      if (itinerary) {
        let features = [
          ...this.MapLayers['0'].getSource().getFeatures(),
          ...this.MapLayers['-1'].getSource().getFeatures()
        ];
        const selectedID = selectedItem && selectedItem.id;

        features.map(feature => {
          let properties = feature.getProperties();

          if (properties.type) {
            if (properties.type.includes('builder')) {
              properties.type = 'builder';
            }
          }

          if (selectedID !== properties.id) {
            properties.type =
              properties.type === 'shop' ||
              properties.type === 'restaurant' ||
              properties.type === 'builder'
                ? 'place'
                : properties.type;
            const style = this.renderFeatureStyle(properties);

            feature.setStyle(style);
          }
        });

        const markers = this.MapLayers['markers'].getSource().getFeatures();
        markers.map(marker => {
          marker.getGeometry().setCoordinates([0, 0]);
        });

        this.setState({
          itinerary: false
        });
      }
    }

    // Select item
    if (defaultSelectItem) {
      this.selectItem(defaultSelectItem, true);
    }
  }

  itinerary = (floor, itineraryStart, itineraryFinish) => {
    const features = this.MapLayers[floor].getSource().getFeatures();

    features.map(item => {
      const itemProperties = item.getProperties();
      const hasData = itemProperties.name ? true : false;
      const label = itemProperties.label;

      if (
        itemProperties.id !== itineraryFinish.id ||
        itemProperties.id !== itineraryStart.id
      ) {
        let style;
        if (itemProperties.building) {
          style = renderStyle(this.Ol, 'building', false);
        } else {
          const type =
            itemProperties.type === 'historic' ? 'historic' : 'itinerary';
          style = renderStyle(this.Ol, type, hasData);
        }
        if (label) {
          const text = new this.Ol.style.Style({
            text: new this.Ol.style.Text({
              text: label.replace(' ', '\n'),
              textAlign: 'center',
              font:
                'bold ' +
                this.state.fontSize +
                'px Brandon Grotesque, Helvetica, sans-serif',
              fill: new this.Ol.style.Fill({
                color: 'rgba(94, 94, 94, 0.3)'
              }),
              overflow: true
            })
          });

          item.setStyle([style, text]);
        } else {
          item.setStyle(style);
        }
      }

      if (
        itemProperties.id === itineraryStart.id ||
        itemProperties.id === itineraryFinish.id
      ) {
        const itinerary =
          itemProperties.id === itineraryStart.id
            ? itineraryStart
            : itineraryFinish;
        const type = itinerary.shop ? itinerary.shop.type : itinerary.type;

        const style = renderStyle(this.Ol, type);
        if (label) {
          const text = new this.Ol.style.Style({
            text: new this.Ol.style.Text({
              text: label.replace(' ', '\n'),
              textAlign: 'center',
              font:
                'bold ' +
                this.state.fontSize +
                'px Brandon Grotesque, Helvetica, sans-serif',
              fill: new this.Ol.style.Fill({
                color: '#FFFFFF'
              }),
              overflow: true
            }),
            zIndex: 50
          });

          item.setStyle([style, text]);

          const icon =
            itemProperties.id === itineraryStart.id
              ? 'markerUser'
              : 'markerEvent';
          const geometry = item.getGeometry().getExtent();
          let center = this.Ol.extent.getCenter(geometry);

          let feature = this.MapLayers['markers']
            .getSource()
            .getFeatureById(icon);
          feature.getGeometry().setCoordinates(center);
        } else {
          item.setStyle(style);
        }
      }
    });
  };

  selectItem = (item, defaultItem) => {
    if (this.MapLayers) {
      const groundLevel = this.MapLayers['0'].getSource().getFeatures();
      const subLevel = this.MapLayers['-1'].getSource().getFeatures();

      let place = null;
      place = subLevel.find(feature => {
        const properties = feature.getProperties();
        return properties.id === item.id;
      });

      if (!place) {
        place = groundLevel.find(feature => {
          const properties = feature.getProperties();
          return properties.id === item.id;
        });
        this.MapLayers['-1'].setVisible(false);
        this.MapLayers['0'].setVisible(true);
        this.MapLayers['infoFloor0'].setVisible(true);
        this.props.updatefloor(0);
      } else {
        this.MapLayers['-1'].setVisible(true);
        this.MapLayers['0'].setVisible(false);
        this.MapLayers['infoFloor0'].setVisible(false);
        this.props.updatefloor(-1);
      }

      if (place && place.getGeometry()) {
        const properties = place.getProperties();
        const geometry = place.getGeometry().getExtent();
        const center = this.Ol.extent.getCenter(geometry);
        this.OlMap.getView().setCenter(center);
        this.OlMap.getView().setZoom(19);

        let featureType = properties.type;
        if (featureType === 'place' && defaultItem) {
          featureType = 'selectedPlace';
        }
        const featureStyle = renderStyle(this.Ol, featureType, defaultItem);
        const featureTextStyle = new this.Ol.style.Style({
          text: new this.Ol.style.Text({
            text: defaultItem ? item.label : properties.label,
            textAlign: 'center',
            font:
              'bold ' +
              this.state.fontSize +
              'px Brandon Grotesque, Helvetica, sans-serif',
            fill: new this.Ol.style.Fill({
              color: '#FFFFFF'
            }),
            overflow: true
          })
        });

        place.setStyle([featureStyle, featureTextStyle]);
      }
    }
  };

  renderFeatureStyle = data => {
    const { fontSize } = this.state;

    let style = [];
    if (data.building) {
      style = renderStyle(this.Ol, 'building', false);
    } else {
      style = renderStyle(this.Ol, data.type, data.shop);
    }

    if (data && data.label) {
      const text = data.label.replace(' ', '\n');
      const textStyle = new this.Ol.style.Style({
        text: new this.Ol.style.Text({
          text: text,
          textAlign: 'center',
          font:
            'bold ' + fontSize + 'px Brandon Grotesque, Helvetica, sans-serif',
          fill: new this.Ol.style.Fill({
            color: '#5E5E5E'
          }),
          overflow: true
        })
      });

      style = [style, textStyle];
    }

    return style;
  };

  /**
   * renderFeature
   *
   * @param {String}  floor
   * @param {Object}  data  Information of a place
   */
  renderFeature = (floor, data) => {
    const coordinates = data && data.area && data.area.coordinates;
    const type = data && data.area && data.area.type;

    if (coordinates <= 0) return;

    let geometry = null;

    switch (type) {
      case 'Polygon':
        geometry = new this.Ol.geom.Polygon(coordinates);
        break;

      case 'Point':
        geometry = new this.Ol.geom.Point(coordinates[0][0]);
        break;

      case 'LineString':
        geometry = new this.Ol.geom.LineString(coordinates[0]);
        break;
    }

    geometry.applyTransform(
      this.Ol.proj.getTransform('EPSG:4326', 'EPSG:3857')
    );
    let feature = new this.Ol.Feature(geometry);

    let style;

    // Roads
    if (type === 'LineString' && data.type !== 'unavailable') {
      if (data.type === 'services') {
        const featureStyle = renderStyle(this.Ol, 'hidden');
        const text = new this.Ol.style.Style({
          text: new this.Ol.style.Text({
            text: data.name.toUpperCase(),
            textAlign: 'center',
            placement: 'line',
            font:
              'bold ' +
              this.state.fontSize * 1.5 +
              'px Brandon Grotesque, Helvetica, sans-serif',
            fill: new this.Ol.style.Fill({
              color: '#423E38'
            })
          }),
          zIndex: 10
        });

        style = [featureStyle, text];
      }
    } else if (type === 'Point' && data.type === 'services') {
      style = new this.Ol.style.Style({
        image: new this.Ol.style.Icon(
          /** @type {olx.style.IconOptions} */ ({
            anchor: [0.5, 0.5],
            anchorOrigin: 'top-right',
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: data.image
          })
        )
      });
    } else if (data.type === 'river') {
      style = new this.Ol.style.Style({
        image: new this.Ol.style.Icon(
          /** @type {olx.style.IconOptions} */ ({
            anchor: [0.46, 0.5],
            anchorOrigin: 'top-right',
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: data.image
          })
        )
      });
    } else {
      style = this.renderFeatureStyle(data);
    }

    feature.setStyle(style);

    if (data && data.shop) {
      let details = '';
      if (data.shop.detail !== null) {
        if (data.shop.detail.hasOwnProperty('ttTexte')) {
          details = data.shop.detail.ttTexte;
        }
      }
      feature.setProperties({
        id: data.id,
        shop: data.shop,
        type: data.shop.type,
        label: data.label,
        slug: data.shop.slug,
        name: data.shop.name,
        building: data.building,
        logo2Mob: data.shop.logo2Mob,
        logo2Desk: data.shop.logo2Desk,
        imgDesk: data.shop.imgDesk,
        imgMob: data.shop.imgMob,
        phone: data.shop.ttPhone,
        ttText: details,
        hours: data.shop.ttHours,
        allDays: data.shop.ttAllDays
      });
    } else {
      feature.setProperties({
        id: data.id,
        type: data.type,
        label: data.label || data.name,
        name: data.name,
        building: data.building
      });
    }
    this.MapLayers[floor].push(feature);
  };

  /**
   * renderPlaces
   *
   * @param {Array} places  List of all places
   */
  renderPlaces = places => {
    const { currentFloor, defaultSelectItem } = this.props;
    const { renderedData } = this.state;

    // To render all places
    this.OlMap.getLayers().clear();

    if (!renderedData) {
      let shopGround = [];
      let shopSub = [];
      let infoAll = [];
      let infoGround = [];
      this.MapLayers['infoFloorAll'] = [];
      this.MapLayers['infoFloor0'] = [];

      // Places
      places.map(place => {
        if (place.type !== 'services' && place.type !== 'river') {
          if (place.floor === 0) {
            shopGround.push(place);
          } else {
            shopSub.push(place);
          }
        } else {
          if (place.floors.length > 1) {
            infoAll.push(place);
          } else {
            infoGround.push(place);
          }
        }
      });

      for (const floor in this.MapFloors) {
        this.MapLayers[floor] = [];
        const floorData = floor === '0' ? shopGround : shopSub;

        floorData.map(this.renderFeature.bind(this, floor));

        this.MapLayers[floor] = new this.Ol.layer.Vector({
          source: new this.Ol.source.Vector({
            features: this.MapLayers[floor]
          }),
          visible: false
        });

        this.OlMap.addLayer(this.MapLayers[floor]);

        if (floor === currentFloor.toString()) {
          this.MapLayers[floor].setVisible(true);
        }

        if (floor === '-1') {
          this.MapLayers[floor].setZIndex(10);
        }
      }

      infoAll.map(this.renderFeature.bind(this, 'infoFloorAll'));
      infoGround.map(this.renderFeature.bind(this, 'infoFloor0'));

      // Info all levels
      this.MapLayers['infoFloorAll'] = new this.Ol.layer.Vector({
        source: new this.Ol.source.Vector({
          features: this.MapLayers['infoFloorAll']
        }),
        zIndex: 50
      });

      // Info 0
      this.MapLayers['infoFloor0'] = new this.Ol.layer.Vector({
        source: new this.Ol.source.Vector({
          features: this.MapLayers['infoFloor0']
        }),
        visible: currentFloor === 0 ? true : false
      });

      this.OlMap.addLayer(this.MapLayers['infoFloorAll']);
      this.OlMap.addLayer(this.MapLayers['infoFloor0']);

      if (defaultSelectItem) {
        this.selectItem(defaultSelectItem, true);
      }

      // Set to true to render once
      this.setState({
        renderedData: false
      });
    }
  };

  /**
   * addMapInteractions
   */
  addMapInteractions = () => {
    // Modify cursor on hover
    this.OlMap.on('pointermove', e => {
      const mouseCoord = [e.originalEvent.offsetX, e.originalEvent.offsetY];

      const hit = this.OlMap.forEachFeatureAtPixel(mouseCoord, feature => {
        const data = feature.getProperties();
        if (data.type) {
          if (data.type.includes('builder')) {
            data.type = 'builder';
          }
        }

        if (data.type) {
          if (
            data.type === 'shop' ||
            data.type === 'builder' ||
            data.type === 'restaurant' ||
            data.type === 'other'
          )
            return true;
        }
      });

      if (hit) {
        this.OlMap.getTargetElement().style.cursor = 'pointer';
      } else {
        this.OlMap.getTargetElement().style.cursor = '';
      }
    });

    this.MapSelect = new this.Ol.interaction.Select({
      condition: this.Ol.events.condition.click,
      toggleCondition: this.Ol.events.condition.never,
      multi: false,
      filter: feature => {
        const data = feature.getProperties();
        if (this.props.readOnly) return false;
        if (data.type) {
          if (data.type.includes('builder')) {
            data.type = 'builder';
          }
        }

        if (data.type) {
          if (
            data.type === 'shop' ||
            data.type === 'builder' ||
            data.type === 'restaurant' ||
            data.type === 'other'
          )
            return true;
        }
      }
    });
    this.OlMap.addInteraction(this.MapSelect);

    this.MapSelect.on('select', e => {
      const item = e.target;
      const data =
        item.getFeatures() &&
        item.getFeatures().item(0) &&
        item
          .getFeatures()
          .item(0)
          .getProperties();
      const { fontSize } = this.state;

      if (typeof data !== 'undefined') {
        const selectedItem = e.selected[0];
        const selectedItemText = selectedItem
          .getProperties()
          .label.replace(' ', '\n');

        const featureStyle = renderStyle(this.Ol, data.type);
        const featureTextStyle = new this.Ol.style.Style({
          text: new this.Ol.style.Text({
            text: selectedItemText,
            textAlign: 'center',
            font:
              'bold ' +
              fontSize +
              'px Brandon Grotesque, Helvetica, sans-serif',
            fill: new this.Ol.style.Fill({
              color: '#FFFFFF'
            }),
            overflow: true
          })
        });

        selectedItem.setStyle([featureStyle, featureTextStyle]);

        this.props.selectItem(data);
      }

      const deselectedItem = e.deselected[0];
      if (deselectedItem && deselectedItem.getProperties()) {
        const deselectedItemData = deselectedItem.getProperties();
        const featureStyle = renderStyle(this.Ol, 'place', true);
        const featureTextStyle = new this.Ol.style.Style({
          text: new this.Ol.style.Text({
            text: deselectedItemData.label.replace(' ', '\n'),
            textAlign: 'center',
            font:
              'bold ' +
              fontSize +
              'px Brandon Grotesque, Helvetica, sans-serif',
            fill: new this.Ol.style.Fill({
              color: '#5E5E5E'
            }),
            overflow: true
          })
        });

        deselectedItem.setStyle([featureStyle, featureTextStyle]);
      }
    });
  };

  addMarkers = () => {
    let markers = [];
    const icons = ['markerUser', 'markerEvent'];
    icons.map(icon => {
      let point = new this.Ol.geom.Point([0, 0]);
      point.applyTransform(this.Ol.proj.getTransform('EPSG:4326', 'EPSG:3857'));
      let feature = new this.Ol.Feature(point);

      const marker = '/static/images/' + icon + '.svg';
      const style = new this.Ol.style.Style({
        image: new this.Ol.style.Icon(
          /** @type {olx.style.IconOptions} */ ({
            anchor: [0.5, 1.25],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: marker
          })
        )
      });
      feature.setStyle(style);
      feature.setId(icon);

      markers.push(feature);
    });

    this.MapLayers['markers'] = new this.Ol.layer.Vector({
      source: new this.Ol.source.Vector({
        features: markers
      }),
      zIndex: 100
    });
    this.OlMap.addLayer(this.MapLayers['markers']);
  };

  /**
   * renderMap
   *
   * Init the OpenLayers map
   */
  renderMap = () => {
    this.Ol = require('openlayers');

    this.OlMap = new this.Ol.Map({
      layers: [],
      target: 'map',
      controls: this.Ol.control.defaults({
        attribution: false,
        rotate: false,
        zoom: false
      }),
      view: new this.Ol.View({
        center: this.Ol.proj.fromLonLat([4.8363, 45.7587]),
        rotation: (Math.PI * 74.44726893694495) / 180,
        zoom: 19,
        minZoom: 17.5,
        maxZoom: 20
      }),
      interactions: this.Ol.interaction.defaults({
        mouseWheelZoom: false
      })
    });

    this.setState({
      currentZoom: this.OlMap.getView().getZoom()
    });

    this.addMarkers();
    this.addMapInteractions();
  };

  render() {
    return (
      <Root>
        <MapContainer ref={ref => (this.map = ref)} id="map" />
      </Root>
    );
  }
}

Plan.propTypes = {
  data: PropTypes.array.isRequired,
  itineraryStart: PropTypes.object,
  itineraryFinish: PropTypes.object,
  updatefloor: PropTypes.func.isRequired,
  currentFloor: PropTypes.number.isRequired,
  currentZoom: PropTypes.number.isRequired,
  readOnly: PropTypes.bool,
  selectItem: PropTypes.func.isRequired,
  selectedItem: PropTypes.object,
  defaultSelectItem: PropTypes.object
};

export default Plan;
